import { cva } from 'class-variance-authority'
import React, { FC } from 'react'

import { Loader } from '../loader'
import { ButtonV2Props } from './button-v2.types'

const ButtonV2Styles = cva(
  'text-center p-2 m-0 flex justify-center items-center transition-all border-none border-0 outline-0 cursor-pointer rounded-lg font-montserrat text-base font-medium md:text-sm lg:text-sm disabled:shadow-none disabled:border-transparent disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        primary:
          'bg-blue-50 text-white  hover:bg-blue-60  disabled:bg-grey-5 disabled:text-grey-20',
        secondary:
          'bg-grey-5 text-blue-50  hover:bg-grey-10 disabled:bg-white-gray disabled:text-grey-50',
        tertiary:
          'bg-transparent text-blue-50 hover:text-light-primary underline shadow-none border-none disabled:text-grey-50 underline-button',
      },
      loading: {
        true: 'cursor-wait',
        false: 'cursor-pointer',
      },
      fullWidth: {
        true: 'w-full',
        false: 'w-fit min-w-[82px] md:min-w-[128px] lg:min-w-[128px]',
      },
    },
    compoundVariants: [
      {
        variant: 'primary',
        loading: true,
        className: 'bg-blue-50-disabled',
      },
      {
        variant: 'secondary',
        loading: true,
        className: 'text-grey-50',
      },
      {
        variant: 'tertiary',
        loading: true,
        className: 'text-grey-50',
      },
    ],
  }
)

export const ButtonV2: FC<
  ButtonV2Props & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({
  label,
  variant = 'primary',
  handleClick,
  fullWidth = false,
  disabled = false,
  loading = false,
  type = 'button',
  icon,
}) => {

  const renderIcon = (): React.ReactNode => {
    /*
      - Check to render one icon at a time
      - If loading is true and user also pass icon then only loading is going to show
      - once loading state is false then icon will be shown if user passes it. 
    */
    if (loading && icon) {
      return (
        <Loader
          size= "small"
          color = { 
            variant === 'primary' ? 'var(--grey-30)' : 'var(--grey-50, #797E86)'
          }
        />
      )
    }

    if (loading && !icon) {
      return (
        <Loader size= "small" color = { variant === 'primary' ? 'var(--grey-30)' : 'var(--grey-50, #797E86)' }/>
      )
    }

    if (!loading && icon) {
      return icon
    }
  }

  return (
    <button
      className={`${ButtonV2Styles({
        variant,
        fullWidth,
        loading,
      })}`}
      onClick={ handleClick }
      disabled={ disabled }
      type={ type }
    >
        {(loading || icon) && <div className="mr-2" > { renderIcon() } </div>}
        {label}
    </button>
  )
}
